import React from 'react';
import { BookOpen, Loader2, Scale } from 'lucide-react';
import { TestoRisposta } from './TestoRisposta';

const Fonti = ({ fonti, testid }) => (
  <div className="pt-2 mt-1 border-t border-gray-100 space-y-1" data-testid={`${testid}-fonti`}>
    {fonti.map((f, i) => (
      <p key={f.tag} className="text-[11px] text-gray-600 flex items-start gap-1.5">
        <span className="px-1 rounded bg-sky-100 text-sky-800 font-bold">{i + 1}</span>
        <BookOpen className="h-3.5 w-3.5 mt-px text-gray-400 shrink-0" />{f.nome} · pag. {f.pagina}
      </p>
    ))}
  </div>
);

export const Bolla = ({ m, n }) => {
  const testid = `assistente-msg-${n}`;
  if (m.ruolo === 'utente') {
    return (
      <div className="flex justify-end" data-testid={testid}>
        <div className="max-w-[85%] rounded-2xl rounded-br-md bg-gray-900 text-white px-3.5 py-2.5 space-y-2">
          {m.foto && <img src={m.foto} alt="Foto della domanda" className="rounded-lg max-h-40 object-cover" data-testid={`${testid}-foto`} />}
          <p className="text-sm whitespace-pre-wrap">{m.testo}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-start" data-testid={testid}>
      <div className="max-w-[92%] rounded-2xl rounded-bl-md bg-white border border-gray-200 px-3.5 py-2.5 space-y-2">
        {m.norma && <p className="flex items-center gap-1.5 text-[11px] font-semibold text-amber-800 bg-amber-50 rounded-lg px-2 py-1" data-testid={`${testid}-norma`}><Scale className="h-3.5 w-3.5" />Dalle norme generali: non è nel vostro manuale</p>}
        {m.testo ? <TestoRisposta testo={m.testo} fonti={m.fonti} norma={m.norma} /> : m.inCorso && <p className="text-sm text-gray-500 flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" />Cerco nei vostri documenti...</p>}
        {m.errore && <p className="text-sm text-red-700" data-testid={`${testid}-errore`}>{m.errore}</p>}
        {m.fonti?.length > 0 && <Fonti fonti={m.fonti} testid={testid} />}
      </div>
    </div>
  );
};
